import moment from 'moment'
import { FormattedMessage } from 'react-intl'
import { trackEcommerce, trackEvent, trackGA4Ecommerce } from '../../gtm'
import { roundPrice } from '../../utils'
import { convertCurrency } from '../helpers'
import LiveaboardPricing from '../liveaboard/LiveaboardPricing'
import useCurrentShop from './hooks/useCurrentShop'
import PropTypes from 'prop-types'

export default function Step1({
  slug,
  countrySlug,
  id,
  currency,
  itinerariesLength,
  onSelect,
}) {
  const { shopInfo } = useCurrentShop()
  const handleSelect = (trip) => {
    const price = Number(roundPrice(convertCurrency(trip.price, currency, 'USD')))

    // This can be removed once UA has finally sunset in October 2023.
    trackEcommerce(
      'addToCart',
      {
        checkout: {
          actionField: {
            step: 1,
          },
          products: [
            {
              id: trip.id,
              price,
              brand: `${shopInfo.title}|${window.affiliateId}`,
              name: shopInfo.title,
              variant: `${trip.itinerary.title} / ${moment(trip.startDate)
                .utc()
                .locale('en')
                .format('DD MMM')}-${moment(trip.endDate)
                .utc()
                .locale('en')
                .format('DD MMM')}`,
              category: 'Liveaboard',
              quantity: 1,
            },
          ],
        },
      },
      'USD',
    )
    trackGA4Ecommerce(
      'add_to_cart',
      {
        currency: 'USD',
        value: price,
        items: [
          {
            item_id: trip.id.toString(),
            price,
            item_brand: 'PADI',
            item_name: shopInfo.title,
            item_variant: `${trip.itinerary.title} / ${moment(trip.startDate)
              .utc()
              .locale('en')
              .format('DD MMM')}-${moment(trip.endDate)
              .utc()
              .locale('en')
              .format('DD MMM')}`,
            item_list_name: 'PADI Travel - Liveaboard Listing',
            item_category: 'PADI Travel',
            item_category2: 'Liveaboard',
            quantity: 1,
          },
        ],
      },
      'PADI Travel - Liveaboards',
    )

    trackEvent({
      checkout_cart_value: price,
    })
    onSelect(trip)
  }
  return (
    <div className='step1'>
      <div className='main-content mobile-small-padding new-pricing'>
        <h2 className='step-title'>
          <span className='number'>1</span>
          <FormattedMessage id='select_trip' defaultMessage='Select trip' />
        </h2>
        <LiveaboardPricing
          slug={slug}
          countrySlug={countrySlug}
          id={id}
          currency={currency}
          itinerariesLength={itinerariesLength}
          duration={itinerariesLength}
          isCheckout
          onSelect={handleSelect}
        />
      </div>
    </div>
  )
}

Step1.propTypes = {
  slug: PropTypes.string,
  countrySlug: PropTypes.string,
  id: PropTypes.string,
  currency: PropTypes.string,
  itinerariesLength: PropTypes.number,
  onSelect: PropTypes.func,
}
